import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';

@Component({
  selector: 'iris-copy-field',
  templateUrl: './copy-field.component.html',
  styleUrls: ['./copy-field.component.scss'],
  imports: [
    FormsModule,
    TranslatePipe,
    StrakitButtonComponent,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisCopyFieldComponent {
  private readonly clipboardService = inject(ClipboardService);

  @Input() value: string;
  @Input()  buttonLabel = 'label.dms.CopyLink';
  @Output() copied = new EventEmitter<void>();

  copyToClipboard(): void {
    this.clipboardService.copyFromContent(this.value);
    this.copied.emit();
  }
}
